import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";

export const loginAdmin = async (login, password) => {
  try {
    const response = await axiosInstance.post(`/api/admin/login`, {
      login,
      password,
    });

    const { accessToken } = response.data;
    localStorage.setItem("accessToken", accessToken);

    return {
      success: true,
      token: accessToken,
    };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Přihlášení se nezdařilo. Zkuste to prosím později."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const fetchAllUsers = async () => {
  try {
    const response = await axiosInstance.get(`/api/admin/users`);

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání odběratelů."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const fetchConfigs = async () => {
  try {
    const response = await axiosInstance.get(`/api/admin/configs`);

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání konfigurace."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const changeConfigValue = async (name, value) => {
  try {
    const response = await axiosInstance.post(`/api/admin/configs`, {
      name,
      value,
    });

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při uložení konfigurace."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const sendTestEmail = async (recipient) => {
  try {
    const response = await axiosInstance.post(`/api/admin/test-email`, null, {
      params: { recipient },
    });

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při odesílání testovacího e-mailu."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const sendTestSms = async (phone) => {
  try {
    const response = await axiosInstance.post(`/api/admin/test-sms`, null, {
      params: { phone },
    });

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při odesílání testovací SMS."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const fetchStatisticsData = async (fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(`/api/admin/statistics`, {
      params: { fromDate, toDate },
    });

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání statistiky."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const changePassword = async (cisloOdberatele, newPassword) => {
  try {
    const response = await axiosInstance.post(`/api/admin/change-password`, {
      cisloOdberatele,
      newPassword,
    });

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při změně hesla."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const fetchSuperusers = async () => {
  try {
    const response = await axiosInstance.get(`/api/admin/superusers`);

    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání web odběratelů."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const toggleUserRole = async (cisloOdberatele) => {
  try {
    await axiosInstance.patch(`/api/admin/users/${cisloOdberatele}`);

    return { success: true };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při změně role odběratele."
    );

    return {
      success: false,
      status,
      message,
    };
  }
};

export const updateLoginContacts = async (cisloOdberatele, email, telefon, mfaTyp) => {
  try {
    await axiosInstance.patch(`/api/admin/users/${cisloOdberatele}/login-contacts`, {
      email,
      telefon,
      mfaTyp,
    });
    return { success: true };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Přihlašovací kontakty se nepodařilo uložit."
    );
    return { success: false, status, message };
  }
};
